import { useGetDealStatusInfo } from '../baseDealFooter/useGetDealStatusInfo';
import { Badge } from '@interstate/components/Badge';

export const CompactUIHeaderDealInfo = () => {
    const { isVisible, icon, text, isWarning } = useGetDealStatusInfo();

    if (!isVisible) {
        return null;
    }

    return (
        <Badge variant={isWarning ? 'caution' : 'transparent'} startIcon={icon}>
            {text}
        </Badge>
    );
};
